import { render, staticRenderFns } from "./ConnectionsList.vue?vue&type=template&id=612e26e4&"
import script from "./ConnectionsList.vue?vue&type=script&lang=ts&"
export * from "./ConnectionsList.vue?vue&type=script&lang=ts&"
import style0 from "./ConnectionsList.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports